import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectCurrentUserProfile, selectUserSiteId } from '@libs/store';
import { routes } from '@libs/utils';
import { CollaborationsState } from './collaborations.reducer';
import { collaborationsStateKey } from './collaborations.state-key';

const selectApp = createFeatureSelector<CollaborationsState>(collaborationsStateKey);

export const selectUnreadCollaborationIds = createSelector(selectApp, selectUserSiteId, selectCurrentUserProfile, (s, siteId, profile) => {
  if (siteId === routes.showcaseSiteId) {
    return s.unreadShowcaseCollaborationIds;
  }

  const supportCollabId = profile?.supportCollaborationId;
  // support collab belongs to showcase
  const supportCollabHasUnreadMessages = supportCollabId ? s.unreadShowcaseCollaborationIds.includes(supportCollabId) : false;

  if (supportCollabHasUnreadMessages) {
    return [...s.unreadNonShowcaseCollaborationIds, supportCollabId];
  }

  return s.unreadNonShowcaseCollaborationIds;
});
